import Icon from '../components/Icon.vue'

Icon.register({
  hdd: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M576 304v96c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM528 224h-480-0.1c-8.8 0-22.6 2.8-30.7 6.2l96.5-144.8c7.9-11.8 25.8-21.4 39.9-21.4h268.6c14.2 0 32.1 9.6 39.9 21.4l96.5 144.8c-8.1-3.4-21.9-6.2-30.7-6.2h-0.1zM480 320c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM384 320c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hdd.js
// module id = 1444
// module chunks = 0